import React from 'react';

const NoMatch = () => {

  React.useEffect(() => {
    window.location.replace('https://www.premiercooperative.net/');
  }, []);

  return (
    <>
    </>
  );
}

export default NoMatch;
